const staticUrl = (): string => {
  if (!process.env.REACT_APP_ENVIRONMENT) {
    return 'https://static.nawozy.eu/';
  }
  if (process.env.REACT_APP_ENVIRONMENT === 'local') {
    return 'https://statictest.nawozy.eu/'
  }
  return process.env.REACT_APP_ENVIRONMENT
    ? process.env.REACT_APP_ENVIRONMENT === 'test'
      ? 'https://statictest.nawozy.eu/'
      : 'https://static.nawozy.eu/'
    : 'https://static.nawozy.eu/';
};
export default staticUrl;
